<template>
    <div class="user-cell" @mouseenter="showMenu = true" @mouseleave="hideMenu">
        <div v-if="user" class="user-info">
            <AgentAvatar :userID="user._id" :size="32" />
            <span class="user-name">{{ user.name }}</span>
        </div>
        <a v-else @click="showUserPicker">+ Kullanıcı Ekle</a>
        <div class="user-menu" @mouseenter="cancelHide" @mouseleave="hideMenu" v-if="showMenu && user">
            <SupsisButton icon="edit" @click="editUser" xxsmall />
            <SupsisButton icon="delete" @click="removeUser" xxsmall />
        </div>
        <Modal2 v-if="showModal" @cancel="closeModal" :title="'Kullanıcı Seç'" :okText="'Kaydet'" xlarge
        className="user-picker-modal  keydown-prevent-modal"
        >
            <UserPicker @user-selected="onUserSelected" />
        </Modal2>
    </div>
</template>

<script>
import Vue from "vue";
import AgentAvatar from "../../../../../components/common/AgentAvatar.vue";
import Modal2 from "../../../../../components/common/Modal2.vue";
import UserPicker from "../pickers/UserPicker.vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "UserCell",
    components: {
        AgentAvatar,
        Modal2,
        UserPicker,
        SupsisButton,
    },
    props: {
        record: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showModal: false,
            showMenu: false,
            hideTimeout: null,
        };
    },
    computed: {
        user() {
            const userId = this.record.data[this.field._id];
            if (typeof userId === "string") {
                return this.$store.state.user.users.data.find((user) => user._id === userId) || null;
            }
            return userId || null;
        },
    },
    methods: {
        showUserPicker() {
            if (this.readonly) {
                this.$message.error("Seçim modu içinde bu alanı düzenleyemezsiniz");
                return;
            }
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        async onUserSelected(user) {
            try {
                await this.$emit("update-record", {
                    recordId: this.record._id,
                    fieldId: this.field._id,
                    value: user._id,
                });
                this.closeModal();
            } catch (error) {
                console.error("Kayıt güncellenirken hata oluştu:", error);
                this.$message.error("Kayıt güncellenirken bir hata oluştu");
            }
        },
        editUser() {
            if (this.readonly) {
                this.$message.error("Seçim modu içinde bu alanı düzenleyemezsiniz");
                return;
            }
            this.showUserPicker();
        },
        async removeUser() {
            if (this.readonly) {
                this.$message.error("Seçim modu içinde bu alanı düzenleyemezsiniz");
                return;
            }
            try {
                await this.$emit("update-record", {
                    recordId: this.record._id,
                    fieldId: this.field._id,
                    value: null,
                });
                this.$message.success("Kullanıcı başarıyla kaldırıldı");
            } catch (error) {
                console.error("Kullanıcı kaldırılırken hata oluştu:", error);
                this.$message.error("Kullanıcı kaldırılırken bir hata oluştu");
            }
        },
        hideMenu() {
            this.hideTimeout = setTimeout(() => {
                this.showMenu = false;
            }, 200);
        },
        cancelHide() {
            clearTimeout(this.hideTimeout);
        },
    },
});
</script>

<style scoped lang="scss">
.user-cell {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;

    .user-info {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .user-name {
        font-weight: 500;
    }

    .user-menu {
        position: absolute;
        right: -14px;
        top: 50%;
        transform: translateY(-50%);
        transition: transform 0.3s ease;
        z-index: 10;
        height: 100%;
        width: max-content;
        background: #0000002b;
        display: flex;
        justify-content: flex-end;
        gap: 5px;
        align-items: center;
        padding: 0 10px;
    }
}
</style>
